import React,{useState,useEffect} from 'react';
import {Typography, Grid } from '@mui/material';
import AuthUser from '../../../Components/Auth/AuthUser';
import { useDispatch } from 'react-redux';
import { fetchData } from '../../../redux/apiSlice';
import Moment from 'moment';
import formatPhoneNumber from '../../../../src/Components/Formats/PhoneNumberValidation';

let companyname;
function  CompanyExpandedRow(props) {
    const dispatch = useDispatch();
   const [companyDetails, setcompanyDetails] = useState([]);
    const [aidList,setAIDList] = useState([]);
    const [pidList,setPIDList] = useState([]);
//fetch user details start


const fetcCompanydata = async() => {
    const apiUrl = '/companyDetails/'+ props.companyId ;
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
      if(res.success == true){
          setcompanyDetails(res.company_details)
          // setAIDList(res.aids)
          // setPIDList(res.pids)
      }else {
          alert("Some thing went wrong");
          
      }
    }
  };


//fetch user details end


//useeffect start

useEffect(()=>{
    fetcCompanydata();
},[]) 

//useeffect end

return (
<>

        <Grid container spacing={1} sx={{ marginBottom: 3 }}>
              <Grid item xs={3}>
                  <Typography variant="body2" >Affiliate Name :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.reference_affiliates ? (`${companyDetails.reference_affiliates.first_name} ${companyDetails.reference_affiliates.last_name}`) : '' : ''}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Phone :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.reference_affiliates ?companyDetails.reference_affiliates.phone_no ? formatPhoneNumber(companyDetails.reference_affiliates.phone_no) : "N/A": "N/A" : "N/A"}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Communication Email :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.reference_affiliates ? companyDetails.reference_affiliates.communication_email : 'N/A' : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >City :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.reference_affiliates ? companyDetails.reference_affiliates.city : 'N/A' : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >State :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.reference_affiliates ? companyDetails.reference_affiliates.state_code : 'N/A' : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Approval Date :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.reference_affiliates ? companyDetails.reference_affiliates.approved_date? Moment(companyDetails.reference_affiliates.approved_date).format('MM-DD-YYYY') : 'N/A': 'N/A' : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Referral Code :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.referral_code : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Referred By :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{companyDetails ? companyDetails.referred_by?companyDetails.referred_by:"N/A" :"N/A" }</Typography>
              </Grid>
              
        </Grid> 

</>
    );
}


export default CompanyExpandedRow;